// extracted by mini-css-extract-plugin
export default {"root":"BeneficiarBlock_root__shZe-","root_item":"BeneficiarBlock_root_item__LgQuT","container_title":"BeneficiarBlock_container_title__caJI-"};